<template>
  <div>
    <h4>Ingressos Meia-entrada</h4>
    <p>
      Os ingressos meia-entrada são um benefício que permite que os ingressos sejam comprados com um desconto de 50%.</p>
    <p>
      Para configurar os ingressos meia-entrada, basta acessar a aba de edição de lote e marcar <i>É meia-entrada</i>.
    </p>
    <p>
      O que muda quando o ingresso é meia-entrada:
      <ul>
        <li> Limite de 1 ingresso meia-entrada por conta. </li>
        <li> Tela para comprovação do benefício durante a validação do ingresso. </li>
        <li> Se ativado, antes de realizar a compra, será necessário comprovar o benefício. </li>
      </ul>
    </p>
  </div>
</template>

<script>
export const manifest = {
  id: "paper:admin:concessionTickets",
  title: "Ingressos Meia-entrada",
  description: "Entenda como funciona a venda de ingressos meia-entrada",
  keywords: ["meia-entrada", "ingressos", "benefício", "estudante", "idoso", "desconto"],
  relevantIn: [
    "/admin/organization/parties",
    "/admin/organization/parties/:id/management",
    "/admin/organization/parties/:id/management#tickets",
  ],
};

import { mapGetters } from "vuex";
import PartyStatus from "@/utils/partyStatus";
export default {
  methods: {
  },
  computed: {
    ...mapGetters("organization", ["parties"]),
    activeParties() {
      return this.parties.filter((p) => {
        const s = new PartyStatus(p);
        return s.isActive;
      });
    },
  },
};
</script>

<style></style>
